/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';

import { MenusBehaviourState, MenusBehaviourTypes } from './types';

const INITIAL_STATE: MenusBehaviourState = {
  menus_behaviour: {
    sideBar: false,
    feedbackModal: false,
    pathname: '',
    chatbotAssistant: false,
  },
};

const reducer: Reducer<MenusBehaviourState> = (state = INITIAL_STATE, { type, pathname }) => {
  return produce(state, (draft) => {
    switch (type) {
      case MenusBehaviourTypes.OPEN_SIDEBAR:
        draft.menus_behaviour.sideBar = true;
        break;
      case MenusBehaviourTypes.CLOSE_SIDEBAR:
        draft.menus_behaviour.sideBar = false;
        break;
      case MenusBehaviourTypes.OPEN_FEEDBACK_MODAL:
        draft.menus_behaviour.pathname = pathname;
        draft.menus_behaviour.feedbackModal = true;
        break;
      case MenusBehaviourTypes.CLOSE_FEEDBACK_MODAL:
        draft.menus_behaviour.feedbackModal = false;
        break;
      case MenusBehaviourTypes.OPEN_CHATBOT_ASSISTANT:
        draft.menus_behaviour.chatbotAssistant = true;
        break;
      case MenusBehaviourTypes.CLOSE_CHATBOT_ASSISTANT:
        draft.menus_behaviour.chatbotAssistant = false;
        break;
      default:
    }
  });
};

export default reducer;
